/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {DeleteFilled, EditFilled } from "@ant-design/icons/lib/icons";
import { Badge, Button, message, Popconfirm, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { deleteShirt, getShirt } from "../../../config/Redux/action";

const DashboardShirt = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [shirts, setShirts] = useState([]);
  const loading = useSelector((state) => state.product.isLoading);

  const getDataShirt = async () => {
    const res = await dispatch(getShirt());
    setShirts(
      res.map((shirt, index) => {
        return {
          key: shirt.id,
          id: shirt.id,
          no: index + 1,
          image: shirt.data.image_url,
          name: shirt.data.name,
          kind: shirt.data.kind,
          stock: shirt.data.stock,
          price: shirt.data.price,
          promoPrice: shirt.data.promoPrice,
          size: shirt.data.size,
          published: shirt.data.publish,
        };
      }),
    );
  };

  useEffect(() => {
    getDataShirt();
  }, []);

  const handleDelete = (id) => {
    dispatch(deleteShirt(id));
    getDataShirt();
  };

  const handleEdit = (e) => {
    const idShirt = e.currentTarget.value;
    navigate(`/dashboard/shirt/edit/${idShirt}`);
  };

  const dataSource = shirts;
  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      align: 'center',
      width: '2%',
    },
    {
      title: 'image',
      dataIndex: 'image',
      key: 'image',
      align: 'center',
      width: '15%',
      render: (res) => {
        return <img src={res} alt='gambar' width={150} height={150} />;
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      width: '15%',
    },
    {
      title: 'Kinds',
      dataIndex: 'kind',
      key: 'kind',
      align: 'center',
      width: '12%',
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
      align: 'center',
      width: '10%',
      render: (res) => {
        const price = parseInt(res);
        return <span>{`Rp. ${price.toLocaleString(`id-ID`)}`}</span>;
      },
    },
    {
      title: 'Promo Price',
      dataIndex: 'promoPrice',
      key: 'promoPrice',
      width: '10%',
      align: 'center',
      render: (res) => {
        const price = parseInt(res);
        return <span>{`Rp. ${price.toLocaleString(`id-ID`)}`}</span>;
      },
    },
    {
      title: 'Stock',
      dataIndex: 'stock',
      key: 'stock',
      align: 'center',
      width: '5%',
    },
    {
      title: 'Size',
      dataIndex: 'size',
      key: 'size',
      align: 'center',
      width: '12%',
      render: (result) => {
        let data = [];
        Object.keys(result).map((key) => {
          data.push({
            size: key,
            res: result[key],
          });
        });
        const size = data
          .filter((res) => res.res === true)
          .map((res, index) => {
            return (
              <Badge
                key={index}
                status='success'
                text={<span style={{ marginLeft: '-4px' }}>{res.size}</span>}
                style={{ paddingRight: '10px' }}
              />
            );
          });
        return size;
      },
    },
    {
      title: 'Published',
      dataIndex: 'published',
      key: 'published',
      align: 'center',
      width: '5%',
      render: (result) => {
        return result === 'published' ? 'Yes' : 'No';
      },
    },
    {
      title: 'Action',
      key: 'action',
      align: 'center',
      width: '14%',
      render: (result) => {
        return (
          <>
            <Button
              onClick={handleEdit}
              value={result.key}
              icon={<EditFilled />}
              style={{ display: 'inline-block' }}
            />
            <Popconfirm
              onConfirm={() => handleDelete(result.id)}
              title={'Do You Want To Delete Data?'}
              onCancel={() => message.error('Data is Not Deleted')}
            >
              <Button
                icon={<DeleteFilled />}
                danger
                type='primary'
                style={{ display: 'inline-block', marginLeft: '12px' }}
              />
            </Popconfirm>
          </>
        );
      },
    },
  ];

  return <Table dataSource={dataSource} columns={columns} loading={loading} />;
};

export default DashboardShirt;